// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__3vj9-","rootSmall":"AddTileButton_rootSmall__3Orzu"};